import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageSelectorService {

  constructor() { }

  $selectedImages = new Subject();
}
